import { Controller } from 'react-hook-form';
import { cn } from '../../lib/cn';
import { Label } from './label';

export function FormField({ control, name, render, defaultValue }) {
  return (
    <Controller
      control={control}
      name={name}
      defaultValue={defaultValue}
      render={({ field, fieldState }) =>
        render({ field, fieldState, error: fieldState.error })
      }
    />
  );
}

export function FormItem({ className, children, ...props }) {
  return (
    <div className={cn('flex flex-col gap-2', className)} {...props}>
      {children}
    </div>
  );
}

export function FormLabel({ children, required, htmlFor, className }) {
  return (
    <Label className={className} htmlFor={htmlFor} required={required}>
      {children}
    </Label>
  );
}

export function FormDescription({ className, children, ...props }) {
  return (
    <p
      className={cn('text-[11px] leading-relaxed', className)}
      style={{ color: 'var(--dash-text-faint)' }}
      {...props}
    >
      {children}
    </p>
  );
}

export function FormMessage({ error, className, ...props }) {
  if (!error) return null;
  return (
    <p
      className={cn('text-[11px] font-medium', className)}
      style={{ color: '#d61f3f' }}
      {...props}
    >
      {error.message}
    </p>
  );
}
